import { create, StoreApi, UseBoundStore } from 'zustand';
import { CommonResponseModel, createTemplateLibraryDraftPayload, createWhatsappTemplateHeaderVariable, createWhatsappTemplatePayloadForTemplateLibrary, getTemplateDetails, getTemplateLibraryCategory, getTemplateLibraryDraftList, getTemplateLibraryIndustry, getTemplateLibraryList, getTemplateLibraryUseCase, getWhatsappTemplateButtonTypeReponse, getWhatsappTemplateTypeResponse, interactiveType, whatsappTemplateHeaderResponseModel, whatsappTemplateHeaderVariable } from '../models/axiosModel';
import { isTemplateTypeCallPermissionRequest, isTemplateTypeFlow } from '../components/dashboard/channels/global/whatsapp/templates/utils';
import agent from '../services/api';

const isScreenBelow1000 = window.innerWidth < 1000 ? true : false;

interface TemplateLibraryInterface {

  selectedTemplateId: string | null;
  setSelectedTemplateId: (id: string) => void;

  selectedTemplate: createWhatsappTemplatePayloadForTemplateLibrary | null;
  setSelectedTemplate: (template: createWhatsappTemplatePayloadForTemplateLibrary | null) => void;

  filters: {
    useCase: string;
    category: string;
    industry: string;
    search: string;
  };
  setFilters: (filters: Partial<TemplateLibraryInterface['filters']>) => void;

  templateLibraryUseCaseList: getTemplateLibraryUseCase[] | null;
  setTemplateLibraryUseCaseList: (useCases: getTemplateLibraryUseCase[] | null) => void;
  getTemplateLibraryUseCaseListApiCall: () => Promise<CommonResponseModel<getTemplateLibraryUseCase | null>>;

  templateLibraryCategoryList: getTemplateLibraryCategory[] | null;
  setTemplateLibraryCategoryList: (categories: getTemplateLibraryCategory[] | null) => void;
  getTemplateLibraryCategoryListApiCall: () => Promise<CommonResponseModel<getTemplateLibraryCategory | null>>;

  templateLibraryIndustryList: getTemplateLibraryIndustry[] | null;
  setTemplateLibraryIndustryList: (industries: getTemplateLibraryIndustry[] | null) => void;
  getTemplateLibraryIndustryListApiCall: () => Promise<CommonResponseModel<getTemplateLibraryIndustry | null>>;

  templateLibraryList: getTemplateLibraryList[] | null;
  setTemplateLibraryList: (templates: getTemplateLibraryList[] | null) => void;
  getTemplateLibraryListApiCall: () => Promise<CommonResponseModel<getTemplateLibraryList | null>>;

  templateLibraryDraftList: getTemplateLibraryDraftList[] | null;
  setTemplateLibraryDraftList: (drafts: getTemplateLibraryDraftList[] | null) => void;
  getTemplateLibraryDraftListApiCall: () => Promise<CommonResponseModel<getTemplateLibraryDraftList | null>>;
  createDraftTemplate: (draft: createTemplateLibraryDraftPayload) => Promise<CommonResponseModel<createTemplateLibraryDraftPayload | null>>;
  deleteDraftTemplate: (whatsapp_template_draft_id: string) => Promise<CommonResponseModel<null>>;

  viewMode: 'full' | 'grid';
  setViewMode: (mode: 'full' | 'grid') => void;

  filterMode: 'sidebar' | 'horizontal';
  setFilterMode: (mode: 'sidebar' | 'horizontal') => void;

  modifyTemplate: {
    formOpen: boolean;
    setFormOpen: (open: boolean) => void;
    hoverEditTemplateName: boolean;
    setHoverEditTemplateName: (hover: boolean) => void;
  };
  setModifyTemplate: (modifyTemplate: { formOpen: boolean; setFormOpen: (open: boolean) => void }) => void;


  createTemplatePayload: createWhatsappTemplatePayloadForTemplateLibrary;
  setCreateTemplatePayload: (payload: createWhatsappTemplatePayloadForTemplateLibrary) => void;

  templateStatusDetails: getTemplateDetails | null;
  setTemplateStatusDetails: (details: getTemplateDetails | null) => void;

  interactiveTypeList: interactiveType[] | null;
  setInteractiveTypeList: (types: interactiveType[] | null) => void;
  getInteractiveTypeListApiCall: () => Promise<CommonResponseModel<interactiveType | null>>;

  existingTemplateData: createWhatsappTemplatePayloadForTemplateLibrary | null;
  setExistingTemplateData: (data: createWhatsappTemplatePayloadForTemplateLibrary | null) => void;

  whatsappTemplateTypes: getWhatsappTemplateTypeResponse[] | null;
  setWhatsappTemplateTypes: (types: getWhatsappTemplateTypeResponse[] | null) => void;
  getWhatsappTemplateTypesApiCall: () => Promise<CommonResponseModel<getWhatsappTemplateTypeResponse | null>>;

  whatsappTemplateButtonGenericData: getWhatsappTemplateButtonTypeReponse[] | null;
  setWhatsappTemplateButtonGenericData: (data: getWhatsappTemplateButtonTypeReponse[] | null) => void;
  getWhatsappTemplateButtonTypeApiCall: () => Promise<CommonResponseModel<getWhatsappTemplateButtonTypeReponse | null>>;

  whatsappTemplateHeaderTypes: whatsappTemplateHeaderResponseModel[] | null;
  setWhatsappTemplateHeaderTypes: (types: whatsappTemplateHeaderResponseModel[] | null) => void;
  getWhatsappTemplateHeaderTypesApiCall: () => Promise<CommonResponseModel<whatsappTemplateHeaderResponseModel | null>>;

  whatsappTemplateDynamicVarTypes: any[] | null;
  setWhatsappTemplateDynamicVarTypes: (types: any[] | null) => void;
  getWhatsappTemplateDynamicVarTypesApiCall: () => Promise<CommonResponseModel<any | null>>;

  existingHeaderTemplateVariableData: (whatsappTemplateHeaderVariable | createWhatsappTemplateHeaderVariable)[] | null;
  setExistingHeaderTemplateVariableData: (data: (whatsappTemplateHeaderVariable | createWhatsappTemplateHeaderVariable)[] | null) => void;

  files: any[] | null;
  setFiles: (files: any | null) => void;

  inValidId: (string | number)[] | null;
  setInvalidId: (id: (string | number)[] | null) => void;

  invalidPayloadObjectId: number[] | null;
  setInvalidPayloadObjectId: (id: number[] | null) => void;

  setExistingPayloadData: (data: createWhatsappTemplatePayloadForTemplateLibrary | null) => void;
  existingPayloadData: createWhatsappTemplatePayloadForTemplateLibrary | null;

  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void;

  showUnsavedChangesModal: boolean;
  setShowUnsavedChangesModal: (showUnsavedChangesModal: boolean) => void;

  showConnectWabaModal: boolean;
  setShowConnectWabaModal: (showConnectWabaModal: boolean) => void;

  showImportTemplatePopup: boolean;
  setShowImportTemplatePopup: (showImportTemplatePopup: boolean) => void;

  postCreatePopup: false | 'create' | 'update';
  openPostSubmitPopup: (wasUpdate: boolean) => void;
  closePostSubmitPopup: () => void;

  importTemplatePayload: createWhatsappTemplatePayloadForTemplateLibrary | null;
  setImportTemplatePayload: (payload: createWhatsappTemplatePayloadForTemplateLibrary | null) => void;

  importTemplateName: string | null;
  setImportTemplateName: (name: string | null) => void;

  importTemplateJson: string | null;
  setImportTemplateJson: (json: string | null) => void;

  importTemplateFile: File | null;
  setImportTemplateFile: (file: File | null) => void;

  importTemplateFileName: string | null;
  setImportTemplateFileName: (name: string | null) => void;

  importTemplateSelectedTab: number;
  setImportTemplateSelectedTab: (tab: number) => void;

  templateStatus: string | null;
  setTemplateStatus: (status: string | null) => void;

  // Carousel Template
  existingPayloadKey: any[] | null;
  setExistingPayloadKey: (key: any[] | null) => void;

  // Authentication Template
  addExpiryTimeForCode: boolean;
  setAddExpiryTimeForCode: (addExpiryTimeForCode: boolean) => void;
}

export const useTemplateLibraryStore: UseBoundStore<StoreApi<TemplateLibraryInterface>> = create<TemplateLibraryInterface>((set, get) => ({

  selectedTemplateId: null,
  setSelectedTemplateId: (id) => set({ selectedTemplateId: id }),

  selectedTemplate: null,
  setSelectedTemplate: (template) => set({ selectedTemplate: template }),

  filters: {
    useCase: 'All',
    category: 'All',
    industry: 'All',
    search: '',
  },
  setFilters: (filters) => set({ filters: { ...get().filters, ...filters } }),

  templateLibraryUseCaseList: null,
  setTemplateLibraryUseCaseList: (useCases: getTemplateLibraryUseCase[] | null) => set({ templateLibraryUseCaseList: useCases }),
  getTemplateLibraryUseCaseListApiCall: async () => {
    const res = await agent.getTemplateLibraryUseCase.get();
    if (res?.status) {
      set({ templateLibraryUseCaseList: res.data });
    } else {
      set({ templateLibraryUseCaseList: null })
    }
    return res;
  },

  templateLibraryCategoryList: null,
  setTemplateLibraryCategoryList: (categories: getTemplateLibraryCategory[] | null) => set({ templateLibraryCategoryList: categories }),
  getTemplateLibraryCategoryListApiCall: async () => {
    const res = await agent.getTemplateLibraryCategory.get();
    if (res?.status) {
      set({ templateLibraryCategoryList: res.data });
    } else {
      set({ templateLibraryCategoryList: null })
    }
    return res;
  },

  templateLibraryIndustryList: null,
  setTemplateLibraryIndustryList: (industries: getTemplateLibraryIndustry[] | null) => set({ templateLibraryIndustryList: industries }),
  getTemplateLibraryIndustryListApiCall: async () => {
    const res = await agent.getTemplateLibraryIndustry.get();
    if (res?.status) {
      set({ templateLibraryIndustryList: res.data });
    } else {
      set({ templateLibraryIndustryList: null })
    }
    return res;
  },

  templateLibraryList: null,
  setTemplateLibraryList: (templates: getTemplateLibraryList[] | null) => set({ templateLibraryList: templates }),
  getTemplateLibraryListApiCall: async () => {
    const res = await agent.getTemplateLibraryList.get();
    if (res?.status) {
      set({ templateLibraryList: res.data });
    } else {
      set({ templateLibraryList: null })
    }
    return res;
  },

  templateLibraryDraftList: null,
  setTemplateLibraryDraftList: (drafts: getTemplateLibraryDraftList[] | null) => set({ templateLibraryDraftList: drafts }),
  getTemplateLibraryDraftListApiCall: async () => {
    const res = await agent.getTemplateLibraryDraftList.get();
    if (res?.status) {
      set({ templateLibraryDraftList: res.data });
    } else {
      set({ templateLibraryDraftList: null })
    }
    return res;
  },

  createDraftTemplate: async (draft: createTemplateLibraryDraftPayload) => {
    const res = await agent.createDraftTemplate.put(draft);
    return res;
  },

  deleteDraftTemplate: async (whatsapp_template_draft_id: string) => { 
    const res = await agent.deleteDraftTemplate.delete(whatsapp_template_draft_id);
    if (res?.status) {
      set({ templateLibraryDraftList: get().templateLibraryDraftList?.filter((draft) => draft.whatsapp_template_draft_id !== whatsapp_template_draft_id) });
    }
    return res;
  },

  viewMode: 'full',
  setViewMode: (mode) => set({ viewMode: mode }),

  filterMode: 'sidebar',
  setFilterMode: (mode) => set({ filterMode: mode }),

  modifyTemplate: {
    formOpen: isScreenBelow1000 ? false : true,
    setFormOpen: (open) => set({ modifyTemplate: { ...get().modifyTemplate, formOpen: open } }),
    hoverEditTemplateName: false,
    setHoverEditTemplateName: (hover) => set({ modifyTemplate: { ...get().modifyTemplate, hoverEditTemplateName: hover } }),
  },
  setModifyTemplate: (modifyTemplate: { formOpen: boolean; setFormOpen: (open: boolean) => void; hoverEditTemplateName?: boolean; setHoverEditTemplateName?: (hover: boolean) => void }) => 
    set({ modifyTemplate: { ...get().modifyTemplate, ...modifyTemplate } }),

  
  createTemplatePayload: null as unknown as createWhatsappTemplatePayloadForTemplateLibrary,
  setCreateTemplatePayload: (payload) => set({ createTemplatePayload: payload }),

  templateStatusDetails: null,
  setTemplateStatusDetails: (details: getTemplateDetails | null) => set({ templateStatusDetails: details }),

  interactiveTypeList: null,
  setInteractiveTypeList: (types: interactiveType[] | null) => set({ interactiveTypeList: types }),
  getInteractiveTypeListApiCall: async () => {
      const res = await agent.getInteractiveType.get();
      if (res?.status) {
      set({ interactiveTypeList: res.data });
    } else {
      set({ interactiveTypeList: null })
    }
    return res;
  },

  existingTemplateData: null,
  setExistingTemplateData: (data: createWhatsappTemplatePayloadForTemplateLibrary | null) => set({ existingTemplateData: data }),

  whatsappTemplateTypes: null,
  setWhatsappTemplateTypes: (types) => set({ whatsappTemplateTypes: types }),
  getWhatsappTemplateTypesApiCall: async () => {
    const res = await agent.getWhatsappTemplateType.get();
    if (res?.status) {
      const allowedTemplateTypes = res.data?.filter((template: getWhatsappTemplateTypeResponse) => !isTemplateTypeFlow(template?.name));
      set({ whatsappTemplateTypes: allowedTemplateTypes });
    } else {
      set({ whatsappTemplateTypes: null })
    }
    return res;
  },

  whatsappTemplateButtonGenericData: null,
  setWhatsappTemplateButtonGenericData: (data: getWhatsappTemplateButtonTypeReponse[] | null) => set({ whatsappTemplateButtonGenericData: data }),
  getWhatsappTemplateButtonTypeApiCall: async () => {
    const res = await agent.getWhatsappTemplateButtonType.get();
    if (res?.status) {
      set({ whatsappTemplateButtonGenericData: res.data });
    } else {
      set({ whatsappTemplateButtonGenericData: null })
    }
    return res;
  },

  whatsappTemplateHeaderTypes: null,
  setWhatsappTemplateHeaderTypes: (types: whatsappTemplateHeaderResponseModel[] | null) => set({ whatsappTemplateHeaderTypes: types }),
  getWhatsappTemplateHeaderTypesApiCall: async () => {
    const res = await agent.whatsappTemplateHeaderType.get();
    if (res?.status) {
      set({ whatsappTemplateHeaderTypes: res.data });
    } else {
      set({ whatsappTemplateHeaderTypes: null })
    }
    return res;
  },

  whatsappTemplateDynamicVarTypes: null,
  setWhatsappTemplateDynamicVarTypes: (types: any[] | null) => set({ whatsappTemplateDynamicVarTypes: types }),
  getWhatsappTemplateDynamicVarTypesApiCall: async () => {
    const res = await agent.whatsappTemplateDynamicVariableType.get();
    if (res?.status) {
      set({ whatsappTemplateDynamicVarTypes: res.data });
    } else {
      set({ whatsappTemplateDynamicVarTypes: null })
    }
    return res;
  },

  existingHeaderTemplateVariableData: null,
  setExistingHeaderTemplateVariableData: (data: (whatsappTemplateHeaderVariable | createWhatsappTemplateHeaderVariable)[] | null) => set({ existingHeaderTemplateVariableData: data }),

  files: null,
  setFiles: (files: any | null) => set({ files: files }),

  inValidId: null,
  setInvalidId: (id: (string | number)[] | null) => set({ inValidId: id }),

  invalidPayloadObjectId: null,
  setInvalidPayloadObjectId: (id: number[] | null) => set({ invalidPayloadObjectId: id }),

  existingPayloadData: null,
  setExistingPayloadData: (data: createWhatsappTemplatePayloadForTemplateLibrary | null) => set({ existingPayloadData: data }),

  hasUnsavedChanges: false,
  setHasUnsavedChanges: (hasUnsavedChanges: boolean) => set({ hasUnsavedChanges: hasUnsavedChanges }),

  showUnsavedChangesModal: false,
  setShowUnsavedChangesModal: (showUnsavedChangesModal: boolean) => set({ showUnsavedChangesModal: showUnsavedChangesModal }),

  showConnectWabaModal: false,
  setShowConnectWabaModal: (showConnectWabaModal: boolean) => set({ showConnectWabaModal: showConnectWabaModal }),

  showImportTemplatePopup: false,
  setShowImportTemplatePopup: (showImportTemplatePopup: boolean) => set({ showImportTemplatePopup: showImportTemplatePopup }),

  postCreatePopup: false,
  openPostSubmitPopup: (wasUpdate: boolean) => set({ postCreatePopup: wasUpdate ? 'update' : 'create' }),
  closePostSubmitPopup: () => set({ postCreatePopup: false }),

  importTemplatePayload: null,
  setImportTemplatePayload: (payload: createWhatsappTemplatePayloadForTemplateLibrary | null) => set({ importTemplatePayload: payload }),

  importTemplateName: null,
  setImportTemplateName: (name: string | null) => set({ importTemplateName: name }),

  importTemplateJson: null,
  setImportTemplateJson: (json: string | null) => set({ importTemplateJson: json }),

  importTemplateFile: null,
  setImportTemplateFile: (file: File | null) => set({ importTemplateFile: file }),

  importTemplateFileName: null,
  setImportTemplateFileName: (name: string | null) => set({ importTemplateFileName: name }),

  importTemplateSelectedTab: 0,
  setImportTemplateSelectedTab: (tab: number) => set({ importTemplateSelectedTab: tab }),

  templateStatus: null,
  setTemplateStatus: (status: string | null) => set({ templateStatus: status }),

  // Carousel Template
  existingPayloadKey: null,
  setExistingPayloadKey: (key: any[] | null) => set({ existingPayloadKey: key }),

  // Authentication Template
  addExpiryTimeForCode: true,
  setAddExpiryTimeForCode: (addExpiryTimeForCode: boolean) => set({ addExpiryTimeForCode: addExpiryTimeForCode }),

}));
